import { render, staticRenderFns } from "./MusicDetails.vue?vue&type=template&id=5673f71a&scoped=true"
import script from "./MusicDetails.vue?vue&type=script&lang=js"
export * from "./MusicDetails.vue?vue&type=script&lang=js"
import style0 from "./MusicDetails.vue?vue&type=style&index=0&id=5673f71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673f71a",
  null
  
)

export default component.exports